/**
 * 直播nav
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';

class ImgNav extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        /* eslint-disable no-confusing-arrow */
        return content.map(
            (item, index) =>
                item.isShow ? (
                    <a key={index} className={styles.nav_link} href={item.url} target="_blank">
                        <img src={item.src} width={item.width} height={item.height} />
                    </a>
                ) : (
                    <div key={index} />
                ),
        );
        /* eslint-enable no-confusing-arrow */
    }
}

export default errorBoundary(ImgNav);
